import { createSlice } from "@reduxjs/toolkit"
import { AppThunk } from "../../store";
import { NameValueEntity } from "../../../models/Common";
import { getClaimLookupsLoaded } from "./WarrantyClaimSelector";

interface IProps {
    claimStatusList: Array<NameValueEntity>,
    claimFaultTypeList: Array<NameValueEntity>,
    claimCauseCodeList: Array<NameValueEntity>,
    lookupsLoaded: boolean
}

const initialState: IProps = {
    claimStatusList: [],
    claimFaultTypeList: [],
    claimCauseCodeList: [],
    lookupsLoaded: false
}

const WarrantyClaimSlice = createSlice({
    name: "claims",
    initialState,
    reducers: {
        setClaimStatusListAction: (state, action) => {
            state.claimStatusList = action.payload;
        },
        setClaimFaultTypeListAction: (state, action) => {
            state.claimFaultTypeList = action.payload;
        },
        setClaimCauseCodeListAction: (state, action) => {
            state.claimCauseCodeList = action.payload;
        },
        setLookupsLoadedAction: (state, action) => {
            state.lookupsLoaded = action.payload;
        },
    }
});

export const {
    setClaimStatusListAction,
    setClaimFaultTypeListAction,
    setClaimCauseCodeListAction,
    setLookupsLoadedAction
} = WarrantyClaimSlice.actions;

export const setClaimStatusList = (value: NameValueEntity[]): AppThunk => (dispatch, getState) => {
    dispatch(setClaimStatusListAction(value));
}

export const setClaimFaultTypeList = (value: NameValueEntity[]): AppThunk => (dispatch, getState) => {
    dispatch(setClaimFaultTypeListAction(value));
}

export const setClaimCauseCodeList = (value: NameValueEntity[]): AppThunk => (dispatch, getState) => {
    dispatch(setClaimCauseCodeListAction(value));
}

export const setLookupsLoaded = (value: boolean): AppThunk => (dispatch, getState) => {
    const currentvalue = (getClaimLookupsLoaded(getState()));
    if(currentvalue !== value) {
        dispatch(setLookupsLoadedAction(value));
    }
}

export default WarrantyClaimSlice.reducer;